import { render, staticRenderFns } from "./flatModal.vue?vue&type=template&id=7a9912c3&"
import script from "./flatModal.vue?vue&type=script&lang=js&"
export * from "./flatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports